import { GlobalDataContext } from "@/app/context/global/globalDataContext";
import MyCreatures from "@/app/layout/game/myCreatures";
import Header from "@/app/layout/global/header";
import { Box, Image,  Button, Flex, Link, SimpleGrid, Text } from "@chakra-ui/react";
import NextLink from "next/link";
import { useContext, useEffect, useMemo } from "react";
import { FriendsContext } from "@/app/context/friends/friendsContext";
import { AuthenticationContext } from "@/app/context/authentication/authenticationContext";
import { GameFriendsScore } from "@/app/context/friends/layout/gameFriendsScore";
import { keyframes } from '@emotion/react';
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";
import Footer from "@/app/layout/global/footer";
import { buildChaseUrl } from "@/app/helpers/buildUrlHelper";
import { v4 } from "uuid";
import { useTranslation } from "next-i18next";
import MenuContent from "../global/menuContent";
import Skeleton from "../global/skeleton";
import { BodyHead } from "../global/bodyHead";
import { ContentPriceList } from "@/app/const/contentPriceList";
import { PaymentContext } from "@/app/context/payment/paymentContext";
import { GiCupcake } from "react-icons/gi";


export default function ShoppingLayout() {
    const { t } = useTranslation();
    const uuid = v4()
    
    const {
        language,
        categoryId,
    } = useContext(GlobalDataContext)
    
    const {
        play,
        isGlobalDataUserLoading,
        userState
    } = useContext(GlobalDataUserContext)

    const {
        friendRequestWithUser,
    } = useContext(FriendsContext)
    
    const {
        user,
    } = useContext(AuthenticationContext)
    
    const {
        setShowPaidContentModal
    } = useContext(PaymentContext)

    useEffect(()=>{
        if ( !isGlobalDataUserLoading) {
            //play("shopping01")
        }
    },[isGlobalDataUserLoading])

    return(
        <>
            <BodyHead
                url={process.env.NEXT_PUBLIC_URL as string}
                mainTitle={t("home.title")}
                title={t("home.titleBody")}
                description={t("home.descriptionBody")}
            />
            <Skeleton
                background={<MyCreatures shadow={true}/>}
                header={<Header className="awning" title={t("menu.shopping")} /> }
                menu={<MenuContent/>}
                friends={<>{user && user.email && <GameFriendsScore friends={friendRequestWithUser}/> }</>}
                footer={<Footer>
                </Footer>}
            >
                <>
                    <Text px={5} pt={10} pb={2} opacity={0.5} textAlign="left" size="sm" color="white">{t("shopping.welcome")}</Text>                    
                    <SimpleGrid zIndex={2} columns={{base:2,md:3,lg:4}} spacing={5} w="full" p={5}  pb={20} pt={0}>
                        {ContentPriceList.filter(item=>item.url).map((content, index)=>{   
                            let allow=true
                            if ( content.unblocked && ((!userState?.unblocked) || (userState && userState.unblocked && userState.unblocked.indexOf(content.unblocked) !== -1))) {
                                allow=false
                            }
                            if ( content.blocked && ((userState && userState.unblocked && userState.unblocked.indexOf(content.blocked) === -1))) {
                                allow=false
                            }
                            return(
                                <Flex
                                    key={index}
                                    position="relative"
                                    w="full"
                                    justifyContent="center"
                                    alignItems="center"
                                    flexDir={"column"}
                                    borderRadius={8}
                                    overflow={"hidden"}
                                    opacity={( 
                                        ( userState && userState?.food >= content.price  && content.providerId.cupcake) || 
                                        (content.providerId.stripe ) 
                                        )&& allow?1:0.35}
                                    filter={( 
                                        ( userState && userState?.food >= content.price  && content.providerId.cupcake) || 
                                        (content.providerId.stripe ) 
                                        )&& allow?"grayscale(0%)":"grayscale(75%)"}
                                    onClick={()=>{
                                        if ( 
                                        (( userState && userState?.food >= content.price  && content.providerId.cupcake) || 
                                        (content.providerId.stripe ) ) && allow
                                        ) {
                                        setShowPaidContentModal({itemId:content.id})}
                                    }}
                                    
                                >
                                    <Button
                                        borderBottomRadius={0}
                                        w="full"
                                        bg={content.bg??"black"+"!important"}
                                        color={content.color??"white"+"!important"}
                                        m={0}
                                    >
                                        {t("shopping.title-"+content.id)}
                                    </Button>
                                    <Flex w="full" h="180px" backgroundImage={content.url}
                                    backgroundSize={"cover"}
                                    backgroundPosition={"center"}>
                                        
                                    </Flex>
                                    <Button
                                        borderTopRadius={0}
                                        w="full"
                                        bg={content.bg??"black"+"!important"}
                                        color={content.color??"white"+"!important"}
                                        m={0}
                                        alignItems={"flex-start"}
                                        p={3}
                                    >
                                        <Text>{t("shopping.buy")} : {content.price} </Text> 
                                        <Box pl={1}>{content.providerId.stripe ? " €" : <GiCupcake />}</Box>
                                    </Button>  
                                    <Flex 
                                        position="absolute"
                                        bottom={12}
                                        right={2}
                                        justifyContent={"center"}
                                    >
                                        <Text 
                                            background={"#000000bf"} 
                                            px={4} 
                                            py={2} 
                                            fontSize={"0.7em"} 
                                            borderRadius={10} 
                                            fontWeight="bold" 
                                            lineHeight={"normal"}
                                            color="white"
                                        >
                                            {t("shopping.detail-"+content.id)}
                                        </Text>
                                    </Flex>                                  
                                </Flex>
                            )
                        })}
                        
                    </SimpleGrid>
                </>
            </Skeleton>
            
        </>
    )

}